import React from 'react'
import Upload, { AcceptType } from '../../../../components/Upload'
import { UploadEditIcon } from '../../../../conf/images'
interface ReuploadButtonProps {
    acceptType?: AcceptType
    lt?: number
    onResolve?: (src: string, name: string, type: string) => void
}
const ReuploadButton = (props: ReuploadButtonProps) => {
    return (
        <Upload
            lt={props.lt}
            acceptType={props.acceptType}
            onResolve={props.onResolve}
        >
            <img
                style={{
                    width: '2.8rem',
                    height: '2.8rem',
                    marginLeft: '1rem',
                }}
                src={UploadEditIcon}
                alt='edit'
            />
        </Upload>
    )
}

export default ReuploadButton
